import { initSection } from '../../core/shopify/init-section/index.js';
import { isMobile } from '../../theme/responsive-utils';
const NAMESPACE = '.js-key-features';
initSection(NAMESPACE, (section)=>{
    const content = section.querySelector('.js-key-features-content');
    const visual = section.querySelector('.js-key-features-visual');
    const itemsList = section.querySelector('.js-key-features-list');
    const items = itemsList ? Array.from(itemsList.querySelectorAll('.js-key-features-item')) : [];
    if (!content && !visual && !items.length) return {
        unload: null
    };
    let itemsTriggered = false;
    let itemsTimer = null;
    const triggerAllItems = ()=>{
        if (itemsTriggered) return;
        itemsTriggered = true;
        itemsTimer = setTimeout(()=>{
            items.forEach((item, i)=>{
                item.style.setProperty('--stagger-delay', `${i * 150}ms`);
                item.classList.add('is-revealed');
            });
        }, 200);
    };
    const triggerItem = (item)=>{
        item.style.setProperty('--stagger-delay', '0ms');
        item.classList.add('is-revealed');
    };
    // Observe the heading and visual
    const contentObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const el = entry.target;
                contentObserver.unobserve(el);
                el.classList.add('is-revealed');
            }
        });
    }, {
        threshold: [
            0,
            0.1
        ]
    });
    // Desktop: trigger all items at once
    const desktopItemObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            desktopItemObserver.unobserve(entry.target);
            triggerAllItems();
        });
    }, {
        rootMargin: '0px 0px -100px 0px',
        threshold: 0
    });
    // Mobile: each item observed individually
    const mobileItemObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            mobileItemObserver.unobserve(entry.target);
            triggerItem(entry.target);
        });
    }, {
        rootMargin: '0px 0px -100px 0px',
        threshold: 0
    });
    if (content) contentObserver.observe(content);
    if (visual) contentObserver.observe(visual);
    if (isMobile()) {
        items.forEach((item)=>mobileItemObserver.observe(item));
    } else if (itemsList) {
        desktopItemObserver.observe(itemsList);
    }
    return {
        unload: ()=>{
            contentObserver.disconnect();
            desktopItemObserver.disconnect();
            mobileItemObserver.disconnect();
            if (itemsTimer !== null) clearTimeout(itemsTimer);
        }
    };
});
